import { AppPermissions } from './acl-permissions-constants';
import { ACL_PERMISSIONS_VALUE as ACL } from '@app/core/services/acl/config/acl-permissions';
import { ProductRouteModules } from '@models/enums/product-route-modules';

interface Rules {
    rule: string;
    permissions: string[];
    regex?: boolean;
    module: ProductRouteModules;
}

export const routesPermissionsValue: Rules[] = [
    {
        rule: ACL.MCI_SEARCH,
        permissions: [AppPermissions.mci.search],
        module: ProductRouteModules.MCI,
        regex: true,
    },
    {
        rule: ACL.MCI_WORKLIST,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_PENDING_TRANSACTIONS,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_REPORTS,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_REPORTS_DETAILS,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
        regex: true,
    },
    {
        rule: ACL.MCI_NIGHTLY_BUILD_UPDATE,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_CONSORTIUM,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_MERGE,
        permissions: [AppPermissions.mci.merge],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_SPLIT,
        permissions: [AppPermissions.mci.split],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.LIST_USERS,
        permissions: [AppPermissions.mci.viewUsers],
        module: ProductRouteModules.None,
    },
    {
        rule: ACL.ADD_USER,
        permissions: [AppPermissions.mci.addAndEditUser],
        module: ProductRouteModules.None,
    },
    {
        rule: ACL.EDIT_USER,
        permissions: [AppPermissions.mci.addAndEditUser],
        module: ProductRouteModules.None,
        regex: true,
    },
    {
        rule: ACL.MCI_HELP,
        permissions: [AppPermissions.mci.viewModule],
        module: ProductRouteModules.MCI,
    },
    {
        rule: ACL.MCI_LOGIN_HISTORY,
        permissions: [AppPermissions.mci.addAndEditUser],
        module: ProductRouteModules.None,
    },
    {
        rule: ACL.MCI_DETAILED_ACTIVITY,
        permissions: [AppPermissions.mci.addAndEditUser],
        module: ProductRouteModules.None,
    },
    {
        rule: ACL.MCI_ACTIVITY_LOG,
        permissions: [AppPermissions.mci.addAndEditUser],
        module: ProductRouteModules.None,
    },
];
